export type ProcessOfferScheduleTranslation = {
  button: {
    cancel: string;
    save: string;
  };
  noSchedule: string;
  title: string;
};

export const processOfferScheduleTranslation: ProcessOfferScheduleTranslation = {
  button: {
    cancel: 'Anuluj',
    save: 'Zapisz',
  },
  noSchedule: 'Brak planu',
  title: 'Plan realizacji',
};
